import React, { useState } from 'react';
import Icon from './Icon';

const PlayerSelector = ({ availablePlayers, selectedPlayers, onTogglePlayer, onAddNewPlayer, onBack, onContinue }) => {
  const [newPlayerName, setNewPlayerName] = useState('');
  const [showAddNew, setShowAddNew] = useState(false);

  const handleAddNew = () => {
    if (!newPlayerName.trim()) return;
    onAddNewPlayer(newPlayerName.trim());
    setNewPlayerName('');
    setShowAddNew(false);
  };

  const isSelected = (playerId) => selectedPlayers.some(p => p.id === playerId);

  return (
    <div className="min-h-screen p-4">
      <button onClick={onBack} className="mb-4 text-red-500 flex items-center gap-2">
        <Icon d="M15 19l-7-7 7-7" />
        Retour
      </button>

      <h1 className="text-2xl font-bold mb-4">
        Sélectionner les joueurs ({selectedPlayers.length})
      </h1>

      <div className="mb-6">
        <button
          onClick={() => setShowAddNew(!showAddNew)}
          className="w-full bg-green-600 text-white py-3 rounded-lg font-semibold mb-4 flex items-center justify-center gap-2"
        >
          <Icon d="M12 4v16m8-8H4" />
          Ajouter un nouveau joueur
        </button>

        {showAddNew && (
          <div className="bg-gray-800 p-4 rounded-lg mb-4">
            <div className="flex gap-2">
              <input
                type="text"
                value={newPlayerName}
                onChange={(e) => setNewPlayerName(e.target.value)}
                onKeyPress={(e) => e.key === 'Enter' && handleAddNew()}
                placeholder="Nom du nouveau joueur"
                className="flex-1 bg-gray-700 border border-gray-600 rounded-lg px-4 py-3 focus:outline-none focus:border-green-500"
              />
              <button
                onClick={handleAddNew}
                className="bg-green-600 text-white px-6 rounded-lg font-semibold"
              >
                Ajouter
              </button>
            </div>
          </div>
        )}
      </div>

      <div className="space-y-2 mb-20">
        {availablePlayers.map(player => {
          const selected = isSelected(player.id);
          return (
            <button
              key={player.id}
              onClick={() => onTogglePlayer(player)}
              className={`w-full p-4 rounded-lg text-left transition ${
                selected 
                  ? 'bg-red-600 text-white' 
                  : 'bg-gray-800 text-gray-100 hover:bg-gray-700'
              }`}
            >
              <div className="flex items-center justify-between">
                <div>
                  <div className="font-semibold">{player.name}</div>
                  <div className={`text-sm ${selected ? 'text-red-200' : 'text-gray-400'}`}>
                    {selected ? 'Sélectionné' : 'Cliquer pour sélectionner'}
                  </div>
                </div>
                <div className={`w-6 h-6 rounded-full border-2 flex items-center justify-center ${
                  selected ? 'border-white bg-white' : 'border-gray-400'
                }`}>
                  {selected && <Icon d="M5 13l4 4L19 7" className="w-4 h-4 text-red-600" />}
                </div>
              </div>
            </button>
          );
        })}
      </div>

      <div className="fixed bottom-0 left-0 right-0 p-4 bg-gray-900 border-t border-gray-800">
        <button
          onClick={onContinue}
          disabled={selectedPlayers.length === 0}
          className="w-full bg-red-600 text-white py-4 rounded-lg font-semibold disabled:bg-gray-700 disabled:text-gray-500"
        >
          Continuer avec {selectedPlayers.length} joueur{selectedPlayers.length !== 1 ? 's' : ''}
        </button>
      </div>
    </div>
  );
};

export default PlayerSelector;